<template>
<!-- 外部图文 -->
  <div class="ExtGfxIframeBox" v-loading="singularLoading">
    <!-- Singulartoken模式 -->
    <div class="SingularToken" v-if="SingularMessage.singularStatus == 0">
      <div class="scrollBox">
        <iframe v-if="SingularMessage.token" class="Iframe" :src="iframeUrl"></iframe>
        <p class="megTips" v-else>{{ $t('lang.addSingulartips') }}</p>
      </div>
      <!-- <el-button :disabled="CloneDisabled.Singular" :loading="saveLoading" class="saveBtn" type="success" @click="ResetPgmUlr">{{ $t('lang.Refresh')}} </el-button> -->
    </div>
    <!-- Url模式 -->
    <div class="SingularUrl" v-else-if="SingularMessage.singularStatus == 1">
      <iframe class="Iframe" :src="SingularMessage.appUrl"></iframe>
    </div>
    <!-- flowics token模式 -->
    <div class="FlowicsToken" v-else-if="SingularMessage.singularStatus == 2">
      <div class="scrollBox">
        <iframe v-if="true" class="Iframe" :src="iframeUrl"></iframe>
        <p class="megTips" v-else>{{ $t('lang.addSingulartips') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { mapState } from 'vuex'
export default {
  props: {
    // Singular信息
    SingularMessage: {
      type: Object,
      default: () => ({
        singularStatus: '',
        appUrl: '',
        token: '',
        pgmUrl: '',
        frontUrl: ''
      })
    }
  },
  data () {
    return {
      broadcastUrl: '',
      iframeUrl: '',
      saveLoading: false,
      singularLoading: false
    }
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {
    this.singularLoading = true
    setTimeout(() => {
      this.singularLoading = false
    }, 2000)
    if (this.SingularMessage.singularStatus == 0) {
      this.iframeUrl = `https://app.singular.live/control/${this.SingularMessage.token}?uiLayout=vertical&noHeader=1`
    } else if (this.SingularMessage.singularStatus == 2) {
      this.iframeUrl = this.SingularMessage.frontUrl
    }
  },
  methods: {
    // 刷新pgmUrl
    ResetPgmUlr () {
      this.saveLoading = true
      this.axios
        .post(Outil.getUrl('/singular/output2broadcast'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
          this.saveLoading = false
        }).catch(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.ExtGfxIframeBox {
  height: 100%;
  .SingularToken,.FlowicsToken{
    height: 100%;
    .scrollBox {
      height: 100%;
      overflow-y: scroll;
      .megTips {
        padding: 15px;
        text-align: left;
        color: #999;
      }
    }
    .Iframe {
      min-height: 600px;
    }
    .saveBtn {
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
  }
  .SingularUrl{
    height: 100%;
    .Iframe{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
